import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { ComingSoonPlaceholder } from '../components/layout/ComingSoonPlaceholder'

export const MyProfilePage: FC = () => (
  <AccountLayout>
    <ComingSoonPlaceholder title="Mi perfil" />
  </AccountLayout>
)

export default MyProfilePage
